// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-button[data-v-6bf3a625]{//float:right;font-size:2em;line-height:70px;margin-right:10px;//display:block}.close-button[data-v-6bf3a625]:hover{color:#ee335f;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
